import React from 'react'
import "./Explore.css"
import { ethers } from 'ethers'
import { useEffect, useState } from 'react'
import axios from 'axios'
import Web3Modal from "web3modal"

import {
    marketplaceAddress
} from '../../config'


import NFTMarketplace  from '../../utils/ropston/NFTMarketplace.json'




import Countdown from 'react-countdown';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Footerr from '../Footer/Footerr';

function Ethereum_Item() {



    const [nfts, setNfts] = useState([])
    const [loadingState, setLoadingState] = useState('not-loaded')
    useEffect(() => {
        loadNFTs()
    }, [])
    async function loadNFTs() {
        /* create a generic provider and query for unsold market items */
        // const provider = new ethers.providers.JsonRpcProvider('https://ropsten.infura.io/v3/c1e1ec09acaf40dead35d6ea8af26736')
        const provider = new ethers.providers.JsonRpcProvider('https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161')



        const contract = new ethers.Contract(marketplaceAddress, NFTMarketplace.abi, provider)
        const data = await contract.fetchMarketItems()
    
        /*
        *  map over items returned from smart contract and format 
        *  them as well as fetch their token metadata
        */
        const items = await Promise.all(data.map(async i => {
          const tokenUri = await contract.tokenURI(i.tokenId)
          const meta = await axios.get(tokenUri)
          let price = ethers.utils.formatUnits(i.price.toString(), 'ether')
          let item = {
            price,
            tokenId: i.tokenId.toNumber(),
            seller: i.seller,
            owner: i.owner,
            image: meta.data.image,
            name: meta.data.name,
            description: meta.data.description,
          }
          return item
        }))
        setNfts(items)
        setLoadingState('loaded') 
      }
      async function buyNft(nft) {
        /* needs the user to sign the transaction, so will use Web3Provider and sign it */
        const web3Modal = new Web3Modal()
        const connection = await web3Modal.connect()
        const provider = new ethers.providers.Web3Provider(connection)
        const signer = provider.getSigner()
        const contract = new ethers.Contract(marketplaceAddress, NFTMarketplace.abi, signer)
    
        /* user will be prompted to pay the asking proces to complete the transaction */
        const price = ethers.utils.parseUnits(nft.price.toString(), 'ether')   
        const transaction = await contract.createMarketSale(nft.tokenId, {
          value: price
        })
        await transaction.wait()
        loadNFTs()
      }








//     const contract = new ethers.Contract(marketplaceAddress, NFTMarketplace.abi, provider)
//     const data = await contract.fetchMarketItems()

//     /*
//     *  map over items returned from smart contract and format 
//     *  them as well as fetch their token metadata
//     */
//     const items = await Promise.all(data.map(async i => {
//       const tokenUri = await contract.tokenURI(i.tokenId)
//       const meta = await axios.get(tokenUri)
//       let price = ethers.utils.formatUnits(i.price.toString(), 'ether')
//       let item = {
//         price,
//         tokenId: i.tokenId.toNumber(),
//         seller: i.seller,
//         owner: i.owner,
//         image: meta.data.image,
//         name: meta.data.name,
//         description: meta.data.description,
//       }
//       return item
//     }))
//     setNfts(items)
//     setLoadingState('loaded') 
//   }
//   async function buyNft(nft) {
//     /* needs the user to sign the transaction, so will use Web3Provider and sign it */
//     const web3Modal = new Web3Modal()
//     const connection = await web3Modal.connect()
//     const provider = new ethers.providers.Web3Provider(connection)
//     const signer = provider.getSigner()
//     const contract = new ethers.Contract(marketplaceAddress, NFTMarketplace.abi, signer)

//     /* user will be prompted to pay the asking proces to complete the transaction */
//     const price = ethers.utils.parseUnits(nft.price.toString(), 'ether')  
     
//     const transaction = await contract.createMarketSale(nft.tokenId, {
//       value: price

//     })
//     await transaction.wait()
//     loadNFTs()
//   }











if (loadingState === 'loaded' && !nfts.length) return (<h1 className="px-20 py-10 text-3xl">No items in marketplace</h1>)









    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 10
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 8
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <div>


            <div className=' '>




                <div className='mx-5 mt-5 '>

                    <h1 class="fw-bold  text-capitalize text-light display-5"><span className='headtextt'>Explore</span> Artworks in <span className='headtextt'> ethereum network</span></h1>




                </div>


            </div>

            {/* cards */}


            <div>

                {/* cards start here */}
                <div className='p-4'>


                    {
                        nfts.map((nft, i) => (


                            <div className=' col-lg-3 col-sm-1 col-md-6 d-inline-block p-3 ' >

                                <div className=''>

                                    <div className=' bg-dark  border border-muted rounded-9 '>


                                        <div className='card    rounded-9 bggtimer '>
                                            <div className='card   border border-muted rounded-9 bggtimer'>

                                                <img src={nft.image} className='rounded-9 p-3  ch'></img>

                                                <div className='bg-dark col-sm-12 col-lg-6 col-md-8 mx-auto rounded-9 car-tim  hover-overlay  border border-muted'>
                                                    <a ><h6 className='my-auto  text-light '> <i class="fas fa-clock p-2"></i> <Countdown date={Date.now() + 550000000}></Countdown></h6></a>

                                                    <div class="mask  rounded-9 bgbtt-gra">
                                                        <a ><h6 className='my-auto  text-light'><i class="fas fa-clock p-2"></i><Countdown date={Date.now() + 550000000}></Countdown></h6></a>

                                                    </div>
                                                </div>


                                                <h5 className=' fw-bolder mx-3 text-light'>{nft.name}</h5>
                                                <p className=' fw-bolder mx-3 text-light'>{nft.description}</p>



                                                {/* if you want to show current owner show that */}


                                                {/* <p className=' fw-bolder mx-3 text-light'>owner: <span className='tx-sm'>{nft.owner}</span></p> */}
                                                <p className=' fw-bolder mx-3 text-light'>seller: <span className='tx-sm'>{nft.seller}</span></p>

                                            </div>
                                            <span class="badge rounded-pill badge-notification bg-dark mt-3  p-3 align-self-end  hover-overlay border border-muted" > <i class="fas fa-heart"></i>  60 </span>

                                        </div>
                                        <div className='container'>
                                            <div className='row mt-3 fw-bold text-light'>
                                                <div className='col-6'>
                                                    <h6>RESERVE PRICE</h6>
                                                    <h5>{nft.price}</h5>

                                                </div>
                                                <div className='col-6'>
                                                    <h6>SHARE</h6>
                                                    <h6><i class="fab fa-facebook-square "><i class="fab fa-twitter mx-3"></i></i><i class="fab fa-instagram"></i></h6>

                                                </div>

                                            </div>

                                            <div className='mx-auto p-1'>
                                                <button className="btn btn-danger col-12 " onClick={() => buyNft(nft)}>Buy</button>
                                            </div>

                                        </div>










                                    </div>

                                </div>
                            </div>))
                    }
                </div>

                


                <div class=" text-center fw-bolder">



                    <a href='' className='mx-2'>01</a>
                    <a href='' className='mx-2'>02</a>
                    <a href='' className='mx-2'>03</a>
                    <a href='' className='mx-2'>04</a>
                    <a href='' className='mx-2'>...</a>
                    <a href='' className='mx-2'>16</a>
                    <a href='' className='mx-2'>Next</a>


                </div>

                <div>

                </div>

            </div>

        </div>
    )
}

export default Ethereum_Item
